import React, { Component } from "react";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";
import { invalidateSession } from "../../common/InvalidateSession";

class AccessDeniedAsBevDisabled extends Component {
  componentDidMount() {
    this.props.history.push("/denied");
    invalidateSession();
  }

  render() {
    return (
      <div className="pageWrapper">
        <div className={styles.brandDiv}>
          <FordLogo className={styles.brandLogo} />
        </div>
        <div className={styles.deniedTitle}>
          {this.props.t("AccessDeniedAsBevDisabled.header")}
        </div>
        <div className={styles.deniedInfo}>
          {this.props.t("AccessDeniedAsBevDisabled.subheader")}{" "}
          {this.props.t("AccessDeniedAsBevDisabled.help")}
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(AccessDeniedAsBevDisabled);
